<template>
  <div class="head">
    <Top></Top>
    <!-- 搜索 S -->
    <div class="serach-box">
      <div class="w serach-width">
        <!-- logo S -->
        <div class="logo">
          <h1>
            <router-link to="/" style="display: block">
              www.rakumart-2c.com
            </router-link>
          </h1>
        </div>
        <div class="fenlei" v-show="show == 'home'">
          <img src="../../assets/img/index-list.png" alt /> カテゴリー
        </div>

        <Serach></Serach>
        <!-- 搜索框  E -->
        <ul class="nav" v-show="show == 'home'">
          <li>
            <a href="javascript:;" class="nav-item" @mouseover="index = 1" @mouseleave="index = 0">
              初めての方
              <transition name="fade">
                <div class="procedure" v-if="index == 1">
                  <router-link to="/course" class="item" target="_blank">利用ガイド</router-link>
                </div>
              </transition>
            </a>
          </li>
          <!-- <li>
            <a
              href="javascript:;"
              class="nav-item"
              @mouseover="index = 2"
              @mouseleave="index = 0"
            >
              会員サービス
              <transition name="fade">
                <div class="procedure" v-if="index == 2">
                  <router-link to="/photography" target="_blank" class="item"
                    >写真撮影</router-link
                  >
                  <router-link to="/logisticsTrace" target="_blank" class="item"
                    >物流追跡</router-link
                  >
                  <router-link to="/fba" target="_blank" class="item"
                    >FBA直送サービス</router-link
                  >
                </div>
              </transition>
            </a>
          </li> -->
          <li>
            <a href="javascript:;" class="nav-item" @mouseover="index = 3" @mouseleave="index = 0">
              料金体系
              <transition name="fade">
                <div class="procedure" v-if="index == 3">
                  <router-link to="/poundage" target="_blank" class="item">手数料</router-link>
                  <router-link to="/freight" target="_blank" class="item">国際送料詳細</router-link>
                  <router-link to="/option" target="_blank" class="item">オプション費用</router-link>
                </div>
              </transition>
            </a>
          </li>
          <li>
            <router-link to="/poundage" target="_blank">自動見積りツール</router-link>
          </li>
        </ul>

        <!-- 购物车 -->
        <shoppingCart></shoppingCart>
      </div>
    </div>

    <!-- 搜索 E -->
  </div>
</template>
<script>
import Top from "./Top";
import Serach from "./Serach";
import shoppingCart from "./shoppingCart";
export default {
  data() {
    return {
      value: "",
      options: [
        {
          value: "选项1",
          label: "中国語",
        },
      ],
      val: "",
      show: this.$route.name,
      index: 0,
    };
  },
  components: {
    Top,
    Serach,
    shoppingCart,
  },
  methods: {
    search() {
      this.$router.push({ name: "list", params: { val: this.val } });
      sessionStorage.setItem("q", this.val);
    },
  },
};
</script>
<style lang='scss' scoped>
.head {
  background-color: #fff;
  position: relative;
}

.serach-box {
  //   border-top: 1PX solid #ccc;
  border-bottom: 2px solid #f3c622;
  background-color: #fff;


  .serach-width {
    position: relative;

    // overflow: hidden;
    .logo {
      h1 {
        height: 100px;
        line-height: 100px;
        font-size: 30px;
        padding: 20px 0;
        overflow: hidden;

        a {
          color: #f3c622;
        }
      }


    }

    .fenlei {
      height: 40px;
      width: 250px;
      background: #f3c622;
      font-size: 20px;
      line-height: 40px;
      color: #fff;
      margin-bottom: -1px;

      img {
        vertical-align: middle;
        margin-left: 20px;
        width: 23px;
      }
    }

    .img {
      position: absolute;
      top: 10px;
      right: 10px;
      width: 142px;
      height: 160px;

      img {
        width: 142px;
        height: 160px;
      }
    }

    .nav {
      position: absolute;
      left: 260px;
      bottom: -1px;

      li {
        float: left;

        a {
          display: block;
          width: 180px;
          height: 40px;
          text-align: center;
          line-height: 40px;
          font-size: 16px;
          color: #333333;
          text-shadow: 0 2px 4px rgba(0, 0, 0, 0.12),
            0 0 6px rgba(0, 0, 0, 0.04);

          &:hover {
            background: #f3c622;
            color: #fff;
          }
        }

        .nav-item {
          position: relative;
          //   &:hover .procedure {
          //     display: block;
          //   }
        }

        .procedure {
          position: absolute;
          //   display: none;
          //   overflow: hidden;
          top: 40px;
          left: 0;
          width: 180px;
          //   height: 40px;
          background: #eee;
          box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.2);
          z-index: 99;

          .item {
            background: #eee;
            color: #333333;

            &:hover {
              color: #f3c622;
            }
          }
        }
      }
    }

    .cart {
      width: 136px;
      height: 40px;
      border: 1px solid #999;
      position: absolute;
      top: 50px;
      right: 0px;
      border-radius: 5px;

      h2 {
        position: absolute;
        top: -5px;
        left: 25px;
        font-size: 20px;
        color: red;
        font-weight: 700;
      }

      span {
        float: left;
        font-size: 14px;
        font-weight: 700;
        color: #f3c622;
        line-height: 40px;
      }

      img {
        // vertical-align: middle;
        margin: 7px 7px 0 13px;
        float: left;
      }
    }
  }
}

.el-input__inner {
  padding: 0 !important;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active below version 2.1.8 */
  {
  opacity: 0;
}
</style>